import DescribeSection from 'components/lens-com/DescribeSection';
import ImageHistory from 'components/lens-com/ImageHistory';
import ProcessSection from 'components/lens-com/ProcessSection';
import moment from 'moment';
import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { handleLoader } from 'redux/counterSlice';
import * as myconst from "../../constants"
import _isEqual from 'lodash/isEqual';
import { deleteCoversation, deleteImage, getImagebyID, historyImages, lensHistory, smartBackground, suggestionImages, uniqueTags, updateTagAndNotes } from 'services/lensService';

interface APItype {
    client_env: string | null,
    image_extension: string,
    user_name: string | null,
    image: string,
    system_prompt: string,
    input_image_id?: string,
    output_image_id?: string[],
    conversation_id: string,
    input_temp_path?: string,
    output_temp_path?: string[],
    notes?: string,
    tag?: string[],
    original_input_image_path?: string,
    title?: string,
    is_save: boolean
}

interface suggestionImagesType {
    client_env: string | null,
    image_extension: string,
    user_name: string | null,
    image: string
}

interface suggestionObject {
    output_image_id: string
    output_path: string
    prompt: string
}
interface suggestionImagesResponse {
    conversation_id: string,
    extension: string,
    input_image_id: string,
    input_path: string,
    suggestion_object: suggestionObject[];
    user_name: string,
}

interface ImageHisotry {
    _id: string,
    conversation_id: string,
    input_image_id: string,
    output_image_id: string[],
    user_name: string,
    image_extension: string,
    input_path: string;
    output_path: string[];
    system_prompt: string;
    notes: string;
    tag: string[];
    created_at: string;
    version: number;
    original_input_image_path?: string;
    title?: string;
}

interface ImageData {
    conversation_id: string,
    input_image_id: string,
    output_image_id: string[],
    user_name: string,
    image_extension: string,
    input_path: string,
    output_path: string[],
    system_prompt: string,
    notes: string,
    tag: string[],
    created_at: string,
    original_input_image_path?: string,
    title?: string,
    is_save: boolean
}

interface HistoryBody {
    source_name: string,
    user_name: string | null,
    client_env: string | null,
    tag_filter?: string[],
}

interface historyByConversationIdType {
    source_name: string,
    conversation_id: string | null,
    client_env: string | null,
    tag_filter?: string[],
}

interface deleteCoversationType {
    client_env: string | null,
    user_name: string | null,
    conv_id: string | null,
    source_name: string | null,
}

const SmartBackground = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const conversationId: string | null = searchParams.get('conversation_id');
    const imageId: string | null = searchParams.get('input_image_id');
    const outputImageId: string | null = searchParams.get('output_image_id');

    const ron_lens_recommendation_image = useSelector((state: any) => state.lens.ron_lens_recommendation_image);
    const recommendation_image_detail = useSelector((state: any) => state.lens.recommendation_image_detail);
    const lensCounter = useSelector((state: any) => state.lens.lensCounter);
    const dispatch = useDispatch();
    const [resize, setResize] = useState<string>('');
    const [data, setData] = useState({});
    const [imageData, setImageData] = useState<ImageData>({
        conversation_id: "",
        input_image_id: "",
        output_image_id: [""],
        user_name: "",
        image_extension: "",
        input_path: "",
        output_path: [""],
        system_prompt: "",
        notes: "",
        tag: [""],
        created_at: "",
        is_save: false
    });
    const [suggestionValue, setSuggestionValue] = useState<suggestionImagesResponse>({
        conversation_id: "",
        extension: "",
        input_image_id: "",
        input_path: "",
        suggestion_object: [],
        user_name: "",
    });
    const [inputValue, setInputValue] = useState<string>('');
    const [tagValue, setTagValue] = useState<string>('');
    const [currentTagValue, setCurrentTagValue] = useState<string>('');
    const [tagList, setTagList] = useState<string[]>([]);
    const [currentTagList, setCurrentTagList] = useState<string[]>([]);
    const [preCurrentTagList, setPreCurrentTagList] = useState<string[]>([]);
    const [saveInputValue, setSaveInputValue] = useState<string>('');
    const [saveCurrentInputValue, setSaveCurrentInputValue] = useState<string>('');
    const [preSaveCurrentInputValue, setPreSaveCurrentInputValue] = useState<string>('');
    const [visible, setVisible] = useState<boolean>(false);
    const [confirm, setConfirm] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<string>("");
    const [deleteC_Id, setDeleteC_Id] = useState<string>("");
    const [isImageHistory, setImageHistory] = useState<boolean>(true);
    const [isTextAreaValid, setIsTextAreaValid] = useState<boolean>(false);
    const [historyImagesById, setHistoryImagesById] = useState<ImageHisotry[]>([]);
    const [isActive, setActive] = useState<boolean>(false);
    const [uniqueTagList, setUniqueTagList] = useState<string[]>([]);
    const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
    const [activeAccordion, setActiveAccordion] = useState<string | null>(null);
    const [activeImage, setActiveImage] = useState<string>(`data:${recommendation_image_detail?.type};base64,${ron_lens_recommendation_image}`);
    const [activeClassImage, setActiveClassImage] = useState<number>(0);
    const [activeClassImageDescribe, setActiveClassImageDescribe] = useState<string>("");
    const [activateSuggestion, setActivateSuggestion] = useState<boolean>(false);

    const reject = () => {
        setConfirm(false);
        setDeleteId("");
        setDeleteC_Id("");
    }
    const handleToggle = (): void => {
        setActive(!isActive);
    };
    const handleImageHistory = (): void => {
        setImageHistory(!isImageHistory);
        // setActiveAccordion(null)
    };

    const apiUrl = process.env.RON_LENS_IMAGE || (window.location.origin === 'https://ron.rysun.in:3001' || window.location.origin === 'https://shoptalk.rysun.com') ? "https://ronimages.rysun.in/" : 'http://43.242.38.46/';
    const handleGenerate = async () => {
        if (inputValue.trim() !== "") {
            try {
                dispatch(handleLoader(true));
                const body: APItype = await {
                    client_env: localStorage.getItem("clientName"),
                    image_extension: imageData?.image_extension === "" ? recommendation_image_detail?.type.replace("image/", "") : imageData?.image_extension,
                    user_name: localStorage.getItem("username"),
                    image: imageData?.image_extension === "" ? ron_lens_recommendation_image : activeImage.replace(`data:image/${imageData?.image_extension};base64,`, ''),
                    system_prompt: inputValue,
                    input_image_id: "",
                    output_image_id: [""],
                    conversation_id: conversationId !== null ? conversationId : "",
                    input_temp_path: "",
                    output_temp_path: [""],
                    notes: "",
                    tag: [""],
                    is_save: false
                }
                if ("original_input_image_path" in imageData) {
                    body.original_input_image_path = imageData.original_input_image_path;
                }
                if (imageData.title !== null) {
                    body.title = imageData.title;
                }
                const { result, error } = await smartBackground(body);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                setActivateSuggestion(true)
                setImageData(result);
                localStorage.setItem("conversation_id", result.conversation_id)
                localStorage.setItem("source_name", "ron_lens_background_change")
                navigate(`/lens/smart-background?conversation_id=${result.conversation_id}&input_image_id=${result.input_image_id}`)
                myconst.imageToBase64(result?.output_path[0]?.replace("/var/www/html/", apiUrl), setActiveImage);
                setActiveClassImage(0);
                setInputValue(result?.system_prompt);
                setCurrentTagList(result?.tag[0] === "" ? [] : result?.tag);
                setPreCurrentTagList(result?.tag[0] === "" ? [] : result?.tag);
                setSaveCurrentInputValue(result?.notes);
                setPreSaveCurrentInputValue(result?.notes);
                // await getHistory("");
                // setActiveAccordion(`flush-collapse/0/${result.conversation_id}`);
                // await historyByConversationIdForSaveAndTagUpdate(result.conversation_id);
                dispatch(handleLoader(false));
            } catch (error: any) {
                dispatch(handleLoader(false));
                toast.error(error, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
        } else {
            setInputValue("")
            setIsTextAreaValid(true)
            // toast.error("Please add the prompt")
        }
    }
    const onSave = async () => {
        try {
            dispatch(handleLoader(true));
            const body: APItype = {
                client_env: localStorage.getItem("clientName"),
                image_extension: imageData?.image_extension,
                user_name: localStorage.getItem("username"),
                image: "",
                system_prompt: imageData?.system_prompt,
                input_image_id: imageData.input_image_id,
                output_image_id: imageData?.output_image_id,
                conversation_id: imageData?.conversation_id,
                input_temp_path: imageData?.input_path,
                output_temp_path: imageData?.output_path,
                notes: saveInputValue,
                tag: tagList,
                is_save: true
            }
            if ("original_input_image_path" in imageData) {
                body.original_input_image_path = imageData.original_input_image_path;
            }
            if (imageData.title !== null) {
                body.title = imageData.title;
            } else {
                body.title = imageData.system_prompt
            }
            const { result, error } = await smartBackground(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            setVisible(false)
            setActivateSuggestion(true)
            await getHistory("");
            setImageData(result);
            setTagValue("")
            setSaveInputValue("");
            setTagList([])
            setCurrentTagList(result?.tag[0] === "" ? [] : result?.tag)
            setPreCurrentTagList(result?.tag[0] === "" ? [] : result?.tag)
            setSaveCurrentInputValue(result.notes)
            setPreSaveCurrentInputValue(result.notes)
            if (result?.conversation_id === activeAccordion?.split("/")[2]) {
                await historyByConversationIdForSaveAndTagUpdate(result?.conversation_id);
            }
            dispatch(handleLoader(false));
            toast.success("Image is saved successfully", {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const getDataByImageId = async (conversationId: string | null, imageId: string | null, isRefresh: boolean) => {
        try {
            dispatch(handleLoader(true));
            const { result, error } = await getImagebyID("ron_lens_background_change", conversationId, imageId);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            if (isRefresh) {
                navigate(`/lens/smart-background?conversation_id=${result.conversation_id}&input_image_id=${result.input_image_id}`, { replace: true })
            } else {
                navigate(`/lens/smart-background?conversation_id=${result.conversation_id}&input_image_id=${result.input_image_id}`)
            }
            setImageData(result);
            setActivateSuggestion(true)
            await getHistory(result.conversation_id);
            myconst.imageToBase64(result?.output_path[0]?.replace("/var/www/html/", apiUrl), setActiveImage);
            setActiveClassImage(0);
            setInputValue(result?.system_prompt);
            setCurrentTagList(result?.tag[0] === "" ? [] : result?.tag);
            setPreCurrentTagList(result?.tag[0] === "" ? [] : result?.tag);
            setSaveCurrentInputValue(result?.notes);
            setPreSaveCurrentInputValue(result?.notes);
            dispatch(handleLoader(false));
        } catch (error: any) {
            dispatch(handleLoader(false));
            if (error === "Data not found") {
                navigate("/lens/smart-background");
                setActiveImage("");
                setImageData({
                    conversation_id: "",
                    input_image_id: "",
                    output_image_id: [""],
                    user_name: "",
                    image_extension: "",
                    input_path: "",
                    output_path: [""],
                    system_prompt: "",
                    notes: "",
                    tag: [""],
                    created_at: "",
                    is_save: false
                })
                setInputValue("")
            } else {
                toast.error(error, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
        }
    }
    const handleOriginalImageClick = async (conversationId: string | null, imageId: string | null, isRefresh: boolean) => {
        try {
            dispatch(handleLoader(true));
            const { result, error } = await getImagebyID("ron_lens_background_change", conversationId, imageId);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            if (isRefresh) {
                navigate(`/lens/smart-background?conversation_id=${result.conversation_id}&input_image_id=original&output_image_id=${result.input_image_id}`, { replace: true })
            } else {
                navigate(`/lens/smart-background?conversation_id=${result.conversation_id}&input_image_id=original&output_image_id=${result.input_image_id}`)
            }
            await getHistory(result.conversation_id);
            result.system_prompt = "";
            result.output_path = [""];
            setActivateSuggestion(true)
            setImageData(result);
            myconst.imageToBase64(result?.original_input_image_path?.replace("/var/www/html/", apiUrl), setActiveImage);
            setInputValue(result?.system_prompt);
            setCurrentTagList(result?.tag[0] === "" ? [] : result?.tag);
            setPreCurrentTagList(result?.tag[0] === "" ? [] : result?.tag);
            setSaveCurrentInputValue(result?.notes);
            setPreSaveCurrentInputValue(result?.notes);
            dispatch(handleLoader(false));
        } catch (error: any) {
            dispatch(handleLoader(false));
            if (error === "Data not found") {
                navigate("/lens/smart-background");
                setActiveImage("");
                setImageData({
                    conversation_id: "",
                    input_image_id: "",
                    output_image_id: [""],
                    user_name: "",
                    image_extension: "",
                    input_path: "",
                    output_path: [""],
                    system_prompt: "",
                    notes: "",
                    tag: [""],
                    created_at: "",
                    is_save: false
                })
                setInputValue("")
            } else {
                toast.error(error, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
        }
    }
    const getHistory = async (c_id: string | null) => {
        try {
            const body: HistoryBody = {
                source_name: "ron_lens_background_change",
                user_name: localStorage.getItem("username"),
                client_env: localStorage.getItem("clientName")
            }
            if (selectedCategories?.length !== 0 && selectedCategories?.every(category => uniqueTagList?.includes(category))) {
                body.tag_filter = selectedCategories
            }
            if (imageData?.conversation_id === activeAccordion?.split("/")[2]) {
                await historyByConversationIdForSaveAndTagUpdate(imageData?.conversation_id);
            }
            const { result, error } = await lensHistory(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            let sortedConversations: any;
            sortedConversations = result.sort((a: any, b: any) => {
                const dateA: any = moment(a.created_at);
                const dateB: any = moment(b.created_at);
                return dateB - dateA;
            });
            // Group conversations by date
            const conversationsByDate: any = {};
            sortedConversations.forEach((conversation: any) => {
                const date = moment(conversation.created_at).format(
                    'YYYY-MM-DD'
                );
                if (!conversationsByDate[date]) {
                    conversationsByDate[date] = [];
                }
                conversationsByDate[date].push(conversation);
            });
            // Organize conversations into different phases
            const today = moment().format('YYYY-MM-DD');
            const yesterday = moment()
                .subtract(1, 'days')
                .format('YYYY-MM-DD');
            const previous7Days = moment()
                .subtract(7, 'days')
                .format('YYYY-MM-DD');
            const previous30Days = moment()
                .subtract(30, 'days')
                .format('YYYY-MM-DD');

            const organizedData: any = {};

            // Add conversations for "Today"
            organizedData['Today'] = conversationsByDate[today] || [];

            // Add conversations for "Yesterday"
            organizedData['Yesterday'] =
                conversationsByDate[yesterday] || [];
            // Add conversations for "Previous 7 days" excluding conversations in "Today" and "Yesterday"
            organizedData['Previous 7 days'] = Object.keys(
                conversationsByDate
            )
                .filter((date) =>
                    moment(date).isBetween(
                        previous7Days,
                        yesterday,
                        null,
                        '[]'
                    )
                )
                .map((date) => conversationsByDate[date])
                .flat()
                .filter((conversation) => {
                    const conversationDate = moment(
                        conversation.created_at
                    ).format('YYYY-MM-DD');
                    return (
                        conversationDate !== today &&
                        conversationDate !== yesterday
                    );
                });

            // Add conversations for "Previous 30 days" excluding conversations in "Previous 7 days"
            // organizedData['Previous 30 days'] = Object.keys(
            //     conversationsByDate
            // )
            //     .filter((date) =>
            //         moment(date).isBetween(
            //             previous30Days,
            //             previous7Days,
            //             null,
            //             '[]'
            //         )
            //     )
            //     .map((date) => conversationsByDate[date])
            //     .flat()
            //     .filter(
            //         (conversation) =>
            //             moment(conversation.created_at).format(
            //                 'YYYY-MM-DD'
            //             ) !== today &&
            //             moment(conversation.created_at).format(
            //                 'YYYY-MM-DD'
            //             ) !== yesterday
            //     );

            // Organize conversations by month, excluding the current month
            const conversationsByMonth: any = {};
            sortedConversations.forEach((conversation: any) => {
                const month = moment(conversation.created_at).format(
                    'MMMM YYYY'
                );
                if (month !== moment().format('MMMM YYYY')) {
                    if (!conversationsByMonth[month]) {
                        conversationsByMonth[month] = [];
                    }
                    conversationsByMonth[month].push(conversation);
                }
            });

            // Add conversations by month to the organized data
            for (const month in conversationsByMonth) {
                organizedData[month] = conversationsByMonth[month];
            }
            await uniqueTagsForFilter();
            setData(organizedData);
            if (c_id !== "") {
                await historyByConversationIdForSaveAndTagUpdate(c_id)
                const temp = myconst.findParentKeyIndex(organizedData, c_id);
                setActiveAccordion(`flush-collapse/${temp}/${c_id}`);
            } else {
                if (conversationId !== null) {
                    const exists = myconst.findConversationId(organizedData, conversationId);
                    if (exists) {
                        await historyByConversationIdForSaveAndTagUpdate(conversationId)
                        const temp = myconst.findParentKeyIndex(organizedData, conversationId);
                        setActiveAccordion(`flush-collapse/${temp}/${conversationId}`);
                    }
                }
            }
            setDeleteC_Id("")
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const historyByConversationId = async (id: string, secondId: string) => {
        setActiveAccordion(prevState => prevState === secondId ? null : secondId);
        if (historyImagesById[0]?.conversation_id !== id) {
            try {
                const body: historyByConversationIdType = {
                    source_name: "ron_lens_background_change",
                    conversation_id: id,
                    client_env: localStorage.getItem("clientName"),
                }
                if (selectedCategories?.length !== 0 && !_isEqual(uniqueTagList?.length === 1 ? [] : uniqueTagList, selectedCategories)) {
                    body.tag_filter = selectedCategories
                }
                dispatch(handleLoader(true));
                const { result, error } = await historyImages(body);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                dispatch(handleLoader(false));
                setHistoryImagesById(result.reverse())
            } catch (error: any) {
                dispatch(handleLoader(false));
                toast.error(error, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
        }
    }
    const historyByConversationIdForSaveAndTagUpdate = async (id: string | null) => {
        try {
            const body: historyByConversationIdType = {
                source_name: "ron_lens_background_change",
                conversation_id: id,
                client_env: localStorage.getItem("clientName")
            }
            if (selectedCategories?.length !== 0 && !_isEqual(uniqueTagList?.length === 1 ? [] : uniqueTagList, selectedCategories)) {
                body.tag_filter = selectedCategories
            }
            // dispatch(handleLoader(true));
            const { result, error } = await historyImages(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            // dispatch(handleLoader(false));
            setHistoryImagesById(result.reverse())
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const deleteImageById = async (image_id: string) => {
        try {
            dispatch(handleLoader(true));
            const { result, error } = await deleteImage("ron_lens_background_change", image_id);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            if (imageId === image_id) {
                navigate("/lens/smart-background");
                setActiveImage("");
                setImageData({
                    conversation_id: "",
                    input_image_id: "",
                    output_image_id: [""],
                    user_name: "",
                    image_extension: "",
                    input_path: "",
                    output_path: [""],
                    system_prompt: "",
                    notes: "",
                    tag: [""],
                    created_at: "",
                    is_save: false
                })
                setInputValue("");
            }
            setActivateSuggestion(true)
            setDeleteId("");
            setConfirm(false);
            await getHistory(deleteC_Id);
            dispatch(handleLoader(false));
            toast.success(result.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            setDeleteId("");
            setDeleteC_Id("");
            setConfirm(false);
        }
    }
    const editTagNotes = async () => {
        try {
            dispatch(handleLoader(true));
            const body = {
                client_env: localStorage.getItem("clientName"),
                source_name: "ron_lens_background_change",
                input_image_id: imageData.input_image_id,
                tag: currentTagList,
                note: saveCurrentInputValue,
            }
            setPreCurrentTagList(currentTagList);
            setPreSaveCurrentInputValue(saveCurrentInputValue);
            const { result, error } = await updateTagAndNotes(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            setActivateSuggestion(true)
            await getHistory(conversationId)
            dispatch(handleLoader(false));
            toast.success(result.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const uniqueTagsForFilter = async () => {
        // dispatch(handleLoader(true));
        try {
            const { result, error } = await uniqueTags("ron_lens_background_change");
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            // dispatch(handleLoader(false));
            setUniqueTagList(result);
        } catch (error: any) {
            // dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const deleteConversationByC_id = async (body: deleteCoversationType) => {
        try {
            const { result, error } = await deleteCoversation(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
        } catch (error: any) {
            // dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const handleSuggestedImages = async () => {
        dispatch(handleLoader(true));
        try {
            const body: suggestionImagesType = {
                client_env: localStorage.getItem("clientName"),
                image_extension: recommendation_image_detail?.type.replace("image/", ""),
                user_name: localStorage.getItem("username"),
                image: ron_lens_recommendation_image
            }
            const { result, error } = await suggestionImages(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            setSuggestionValue(result);
            setActivateSuggestion(false)
            dispatch(handleLoader(false));
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    useEffect(() => {
        if (imageId !== null && conversationId !== null && outputImageId === null) {
            getDataByImageId(conversationId, imageId, true)
        } else if (imageId !== null && conversationId !== null && outputImageId !== null) {
            handleOriginalImageClick(conversationId, outputImageId, true)
        }
    }, [])
    useEffect(() => {
        getHistory("")
    }, [selectedCategories])
    useEffect(() => {
        if (ron_lens_recommendation_image !== "") {
            setActiveImage(`data:${recommendation_image_detail?.type};base64,${ron_lens_recommendation_image}`);
            setImageData({
                conversation_id: "",
                input_image_id: "",
                output_image_id: [""],
                user_name: "",
                image_extension: "",
                input_path: "",
                output_path: [""],
                system_prompt: "",
                notes: "",
                tag: [""],
                created_at: "",
                is_save: false
            })
            handleSuggestedImages();
            navigate(`/lens/smart-background`);
            setInputValue("");
            if (localStorage.getItem("conversation_id") !== null) {
                const body = {
                    client_env: localStorage.getItem("clientName"),
                    user_name: localStorage.getItem("username"),
                    conv_id: localStorage.getItem("conversation_id"),
                    source_name: localStorage.getItem("source_name")
                }
                deleteConversationByC_id(body)
            }
        }
    }, [ron_lens_recommendation_image, lensCounter]);
    const footerContent = (
        <div className="text-left">
            <Button label="Save" onClick={onSave} className="outline-active-btn" />
        </div>
    );
    return (
        <>
            <div className='process-image'>
                <DescribeSection setImageData={setImageData} setActiveImage={setActiveImage} suggestionValue={suggestionValue} isTextAreaValid={isTextAreaValid} handleGenerate={handleGenerate} setResize={setResize} resize={resize} setVisible={setIsTextAreaValid} componentName={"ron_lens_background_change"} setInputValue={setInputValue} inputValue={inputValue} activeImage={activeImage} setActiveClassImageDescribe={setActiveClassImageDescribe} activeClassImageDescribe={activeClassImageDescribe} activateSuggestion={activateSuggestion} />
                <ProcessSection activeClassImage={activeClassImage} preCurrentTagList={preCurrentTagList} setActiveClassImage={setActiveClassImage} editTagNotes={editTagNotes} currentTagList={currentTagList} preSaveCurrentInputValue={preSaveCurrentInputValue} setCurrentTagList={setCurrentTagList} currentTagValue={currentTagValue} setCurrentTagValue={setCurrentTagValue} saveCurrentInputValue={saveCurrentInputValue} setSaveCurrentInputValue={setSaveCurrentInputValue} imageData={imageData} activeImage={activeImage} setActiveImage={setActiveImage} isImageHistory={isImageHistory} setVisible={setVisible} handleToggle={handleToggle} componentName={"ron_lens_background_change"} />
                <ImageHistory handleOriginalImageClick={handleOriginalImageClick} selectedCategories={selectedCategories} setSelectedCategories={setSelectedCategories} uniqueTagList={uniqueTagList} data={data} historyImagesById={historyImagesById} isImageHistory={isImageHistory} handleImageHistory={handleImageHistory} historyByConversationId={historyByConversationId} activeAccordion={activeAccordion} getDataByImageId={getDataByImageId} setConfirm={setConfirm} setDeleteC_Id={setDeleteC_Id} setDeleteId={setDeleteId} setActivateSuggestion={setActivateSuggestion}/>
            </div>
            <div className={isActive ? "fixed-img show" : "fixed-img"}>
                <i className="pi pi-times-circle" onClick={handleToggle}></i>
                <img src={activeImage} alt='lens-img' />
            </div>
            <Dialog className="add-tag-dialog" header="Add tag and notes to Generated Image" visible={visible} style={{ width: '440px' }} onHide={() => { setVisible(false); setTagList([]); setTagValue(""); setSaveInputValue("") }} footer={footerContent}>
                <div className="add-tag-row">
                    <label>Add Tag</label>
                    <InputText disabled={tagList.length > 2} value={tagValue} onKeyDown={(e: any) => { if (e.key === 'Enter') { myconst.handleTagList(tagValue, tagList, setTagList, setTagValue) } }} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTagValue(e.target.value)} placeholder="Add tag" />
                    <Button label="Add" disabled={tagList.length > 2} style={{ opacity: tagList.length > 2 ? "0.5" : "1" }} onClick={() => myconst.handleTagList(tagValue, tagList, setTagList, setTagValue)} className="btn-primary" />
                    <ul className="tags-list">
                        {tagList.map((tag: string, index: number) => (
                            <li key={index}>
                                <span>{tag}<i className="pi pi-times" onClick={() => myconst.handleClearTag(tag, tagList, setTagList)}></i></span>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="add-tag-row">
                    <label>Add Notes</label>
                    <InputTextarea value={saveInputValue} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setSaveInputValue(e.target.value)} placeholder="Describe your experience here" />
                </div>
            </Dialog>
            <ConfirmDialog header="Confirmation" visible={confirm} onHide={() => setConfirm(false)} message={`Are you sure you want to delete this image?`}
                icon="pi pi-exclamation-triangle" accept={() => deleteImageById(deleteId)} reject={reject} />
            <Button onClick={handleImageHistory} label="Image History" outlined icon="pi pi-history" className='outline-icon-btn chat-history-btn' />
        </>
    )
}

export default SmartBackground